import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import LinkOnly from './LinkOnly';
import './Style.scss'
import ReactPlayerLoader from '@brightcove/react-player-loader';

export class TextOverImage extends Component {

    render() {
        var content = this.props.articleObj;
        var containerObjectAttr = this.props.containerObjectAttr;
        const handleErrorImageLoading = ({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = content.attributes.fallbackImageUrl ? content.attributes.fallbackImageUrl : "";
        }
        return (
            <>
                <div className={`banner-image-textOverImg banner-image ${content.attributes.articleRendering}  ${content.attributes.class}`}
                    style={content.attributes.articlePadding ? { padding: `${content.attributes.articlePadding}` } : {}}>

                    <Link to={content && content.attributes && content.attributes.mainImageUrl ? content.attributes.mainImageUrl : ""}>
                        <img src={content.mainImage ? content.mainImage : ""} loading={content && content.attributes && content.attributes.imageFetchPriortityAttr == "lazy" ? "lazy" : content && content.attributes && content.attributes.imageFetchPriortityAttr != "high" && containerObjectAttr && containerObjectAttr.imageFetchPriortityAttr && containerObjectAttr.imageFetchPriortityAttr == "lazy" ? "lazy" : ""} fetchPriority={content && content.attributes && content.attributes.imageFetchPriortityAttr =="high" ? "high" : content && content.attributes && content.attributes.imageFetchPriortityAttr !="lazy" && containerObjectAttr && containerObjectAttr.imageFetchPriortityAttr && containerObjectAttr.imageFetchPriortityAttr == "high" ? "high" : "low"} onError={handleErrorImageLoading} className='img-fluid' alt={content.attributes.altText} /></Link>
                    <div className="banner-text-textOverImg">
                        <div className={`banner-text mobile-banner-text ${content.attributes && content.attributes.titleCss}`} dangerouslySetInnerHTML={{ __html: content.title }}></div>
                        <div className="banner-text-1 mobile-banner-text-1" dangerouslySetInnerHTML={{ __html: content.body }}></div>
                    </div>
                    {content.attributes.linkName ? <LinkOnly articleObj={content} /> : ""}
                    

                    {content.attributes.videoId ?
                        content.attributes.videoType && content.attributes.videoType == "vimeo" ?
                            <iframe src={`https://player.vimeo.com/video/${content.attributes.videoId}`} />
                            :
                            content.attributes.videoType == "brightcove" ?
                                <ReactPlayerLoader
                                    id="playlist-player-id"
                                    playerId={content.playerId ? content.playerId : ""}
                                    accountId={content.accountId ? content.accountId : ""}
                                    videoId={content.attributes.videoId}
                                    options={{
                                        responsive: true,
                                        autoplay: false,
                                        muted: true
                                    }}
                                />
                                : "" : ""}
                </div>
            </>
        )
    }

}

export default TextOverImage
